/* eslint-disable camelcase */
import { useMutation } from '@tanstack/react-query'
import { ConnectionModel, MyConnection, ReactQueryKeys } from '@/types'
import { useContext } from 'react'
import { AxiosContext } from '@/context/Axios'
import useAppStore from '@/store/useAppStore'
import { shallow } from 'zustand/shallow'
import { convertMyConnectionToConnectionModel } from '@/utils/helper'

export const useGetUserConnections = (userID: string) => {
  const axios = useContext(AxiosContext)
  const [userConnections] = useAppStore((state) => [state.user.userConnections], shallow)
  const { setUserConnections } = useAppStore()
  return useMutation({
    mutationKey: [ReactQueryKeys.GET_USER_CONNECTIONS],
    mutationFn: async (page: number): Promise<MyConnection[]> => {
      const response = await axios.api.post('ajax/circles', {
        requestType: 'connList',
        connID: userID,
        format: 'json',
        pageNo: page,
      })
      const data: Record<string, ConnectionModel> = {}
      const users = response.data?.connections || []
      users.forEach((user: MyConnection) => {
        const mapped: ConnectionModel = convertMyConnectionToConnectionModel(user)
        data[user.userID] = mapped
      })
      if (page === 1) setUserConnections(data)
      else setUserConnections({ ...userConnections, ...data })
      return users
    },
  })
}
